import React from 'react';
import { node } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import Icon from '../../icon';

const messages = defineMessages({
  summary: {
    id: 'mdc.wrappers.empty.summary',
    defaultMessage: 'Not found',
  },
});

const EmptyTitle = ({ title }) => (
  <div className="empty-message-title">
    <Icon>info</Icon>{title}
  </div>
);

EmptyTitle.propTypes = {
  title: node,
};

EmptyTitle.defaultProps = {
  title: <FormattedMessage {...messages.summary} />,
};

export default EmptyTitle;
